import React from "react";
import classes from "./Topbar.module.scss";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setCollapsed } from "../../../Store/Project/ProjectSlice";
import {
  Avatar,
  Badge,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RoutesLabelJson from "../../../Utils/RoutesLabel.json";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import logo from "../../../assets/Images/logoNT.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Topbar = () => {
  const dispatch = useDispatch();
  const labels: any = RoutesLabelJson;
  const collapsed = useSelector((state: any) => state.project.collapsed);
  const dashboardScreen = useSelector((state: any) => state.project.dashboard);
  const pathName: string = useLocation().pathname;
  const title: string = labels[pathName];
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

const userDetails:any = sessionStorage.getItem("userDetails")
const UserDetails:any = JSON.parse(userDetails)




  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    if (window.confirm("Are You Sure Want to LogOut")) {
      sessionStorage.clear();
      navigate("/");
    }
  };

  return (
    <>
      <div className={classes.topbarWrapper}>
        <div className={classes.container}>
          <div className={classes.dashTitle}>
            {/* <div
              onClick={() => dispatch(setCollapsed(!collapsed))}
              className={classes.collapse}
            >
              {collapsed ? (
                <ArrowForwardIosIcon fontSize="small" color="action" />
              ) : (
                <ArrowBackIosIcon fontSize="small" color="action" />
              )}
            </div> */}
            <div className={classes.brand}>
              {/* <Avatar alt="" src={logo}>
                F
              </Avatar> */}
              <div className={classes.brandTitle}>FIRSTOCK</div>
            </div>
          </div>
          <div
            style={{
              marginRight: "30px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <div className={classes.notifications}>
              <Badge badgeContent={null} color="success">
                <NotificationsIcon color="action" />
              </Badge>
            </div> */}
            <div className={classes.userInfo} onClick={handleClick}>
              <div>
                {" "}
                <Avatar
                  alt=""
                  style={{
                    background: "rgba(224, 238, 242, 1)",
                    border: "0.5px solid rgba(248, 253, 255, 1)",
                    color: "rgba(0, 103, 121, 1)",
                    fontSize: "14px",
                    fontWeight: 600,
                    height: "30px",
                    width: "30px",
                  }}
                >
                  {UserDetails ? UserDetails.Name.slice(0,2) : ""}
                </Avatar>
              </div>
              <div className={classes.userDetails}>
                <p className={classes.userName}>{UserDetails ? UserDetails.Name : ""}</p>
                <p className={classes.userEmail}>{UserDetails ? UserDetails.Email : ""}</p>
              </div>
              <div>
                <KeyboardArrowDownIcon
                  sx={{
                    transform: open ? "rotate(180deg)" : "",
                    transition: "transform 0.4s ease",
                  }}
                />
              </div>
            </div>
            <div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                sx={{ marginTop: "10px" }}
              >
                <MenuItem
                  sx={{
                    padding: "10px 20px",
                    width: "200px",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    background: "rgba(213, 233, 236, 1)",
                    margin: "0px 10px",
                    borderRadius: "10px",

                    "&:hover": {
                      backgroundColor: "rgba(213, 233, 236, 1)",
                      // color: "rgba(108, 0, 248, 1)",
                    },
                  }}
                  onClick={handleLogout}
                >
                  <ExitToAppIcon />
                  <ListItemText
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      marginLeft: "20px",
                    }}
                  >
                    Logout
                  </ListItemText>
                </MenuItem>
              </Menu>
            </div>
            {/* <Tooltip title="LogOut">
              <IconButton onClick={handleLogout}>
                <ExitToAppIcon />
              </IconButton>
            </Tooltip> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Topbar;
